/**
 * Message contract between the sign-in dialog and the task pane.
 *
 * Office's dialog API only carries strings, so both sides agree on JSON. The pane
 * must treat anything arriving here as untrusted input and validate it — hence
 * `parseDialogMessage` rather than a bare `JSON.parse`.
 */

export type DialogMessage =
    | { type: 'token'; token: string }
    | { type: 'error'; message: string }
    /** Sent by the logout dialog once BOL2 has cleared the cookie and CI session. */
    | { type: 'signed-out' }

export function serialiseDialogMessage(message: DialogMessage): string {
    return JSON.stringify(message)
}

export function parseDialogMessage(raw: string): DialogMessage | null {
    let parsed: unknown
    try {
        parsed = JSON.parse(raw)
    } catch {
        return null
    }

    if (typeof parsed !== 'object' || parsed === null) return null
    const candidate = parsed as Record<string, unknown>

    if (candidate.type === 'token' && typeof candidate.token === 'string' && candidate.token.trim() !== '') {
        return { type: 'token', token: candidate.token }
    }

    if (candidate.type === 'error' && typeof candidate.message === 'string') {
        return { type: 'error', message: candidate.message }
    }

    if (candidate.type === 'signed-out') {
        return { type: 'signed-out' }
    }

    return null
}
